import React from 'react';
import { Box, Heading, Paragraph, Image } from 'components';
import { LargePanelSectionWrapper } from 'libs/rendering/gltf/components/largePanel/styles';
import { staticURL } from 'core/url';
import { clientStore } from 'apps/client/app';
import { observer } from 'mobx-react';
import { ShipmentQuoteCard } from './ShipmentQuoteCard';

interface ShipmentQuotesProps {
  rfqId: string;
  shipmentQuotes: any;
}

export const ShipmentQuotes = observer(
  ({ rfqId, shipmentQuotes }: ShipmentQuotesProps) => {
    const title =
      clientStore.currentPortal === 'INTERMEDIATOR'
        ? 'Quotes (sent to customers)'
        : 'Quotes';
    if (!shipmentQuotes?.length) {
      return (
        <LargePanelSectionWrapper>
          <Heading level={2} size='large'>
            {title}
          </Heading>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Paragraph>There are no quotes added yet.</Paragraph>
            <Image
              src={staticURL('/assets/banners/trimmed/006.svg')}
              sx={{
                height: 120,
                background: 'transparent',
              }}
            />
          </Box>
        </LargePanelSectionWrapper>
      );
    }

    return (
      <LargePanelSectionWrapper>
        <Heading level={2} size='large'>
          {title}
        </Heading>
        <Box mt={4}>
          {shipmentQuotes.map((quote: any) => {
            return (
              <ShipmentQuoteCard
                key={quote.id}
                rfqId={rfqId}
                shipmentQuote={quote}
              />
            );
          })}
        </Box>
      </LargePanelSectionWrapper>
    );
  },
);
